import { Button, Container } from '@mui/material'
import React, { useEffect, useState } from 'react'
import '../styles/Availability.scss'
import ServicesCard from './Cards/ServicesCard'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import UpdateAvailabilityModal from '../modals/UpdateAvailabilityModal'
import { getDataById } from '../apis/generalApis'
import moment from 'moment'
import { ScaleLoader } from 'react-spinners'

const weekDays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

const months = [
  'Januaray',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const Availability = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [bookingsByDate, setBookingsByDate] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [date, setDate] = useState(new Date())
  const [currentMonth, setCurrentMonth] = useState(
    `${months[new Date().getMonth()]} ${new Date().getFullYear()}`,
  )
  const [openAvailabilityModal, setOpenAvailabilityModal] = React.useState(
    false,
  )
  const [selectedDate, setSelectedDate] = useState(
    moment(new Date()).format('YYYY-MM-DD'),
  )

  useEffect(() => {
    getBookingsByDate()
  }, [selectedDate])

  const getBookingsByDate = async () => {
    let body = {
      stylist_id: user?.id,
      date: selectedDate,
    }
    setIsLoading(true)
    let result = await getDataById('get-by-date-bookings', body)
    setIsLoading(false)
    if (result?.success === true) {
      setBookingsByDate(result?.data)
    }
  }

  const handleDateChange = (date) => {
    const chosenDate = moment(new Date(date)).format('YYYY-MM-DD')
    setSelectedDate(chosenDate)
    // getBookingsByDate()
  }

  const formatDay = (date) => {
    let day = weekDays[new Date(date).getDay() - 1]
    if (day === undefined) {
      return 'S'
    }
    return day.charAt(0)
  }
  const toggleUpdateAvailabilityModal = () => {
    setOpenAvailabilityModal(!openAvailabilityModal)
  }

  console.log({bookingsByDate});

  return (
    <div
      className="availability-section row m-0"
      style={{ height: 'calc(100vh - 98px)' }}
    >
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="col-md-8 col-sm-12 col-xs-12 cards-section">
        <div>
          <p className="font-weight-bold fs-24 m-2">{selectedDate}</p>
          <div className="services-cards mb-5 mb-lg-0">
            <div className="row m-0 g-4 pb-3">
              {bookingsByDate &&
                bookingsByDate?.map((booking, index) => (
                  <div
                    className="col-12 col-sm-12 col-md-12 col-lg-6"
                    key={booking?.id}
                  >
                    <div className="avail-services-card-wrapper">
                      <ServicesCard booking={booking} />
                    </div>
                  </div>
                ))}
              {!bookingsByDate && <h5>No bookings found.</h5>}
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 col-sm-12 col-xs-12 side-panel-section text-center">
        <p className="fs-24 mt-4 font-weight-bold">Availability</p>
        <div className="mt-3">
          <Calendar
            className={'calendar'}
            onChange={handleDateChange}
            value={date}
            prev2Label={null}
            next2Label={null}
            prevLabel={<ArrowLeftIcon />}
            nextLabel={<ArrowRightIcon />}
            formatShortWeekday={(locale, date) => formatDay(date)}
          />
        </div>
        <div className="my-5">
          <Button
            disableElevation
            id="btn-primary"
            className="mt-3 text-capitalize px-5"
            onClick={toggleUpdateAvailabilityModal}
          >
            Update Availability
          </Button>
        </div>
      </div>
      <UpdateAvailabilityModal
        toggleUpdateAvailabilityModal={toggleUpdateAvailabilityModal}
        modalOpen={openAvailabilityModal}
      />
    </div>
  )
}

export default Availability